import afriexLogoDark from '@/assets/svg/afriex-new-logo.png';
import afriexLogoWhite from '@/assets/svg/afriex-new-logo-white.png';
import {useDarkMode} from '@/context/ThemeProviderContext';

const ReceiptHeader = () => {
  const {isDark} = useDarkMode();
  return (
    <div className="m-7">
      <div className="logoCon items-center flex gap-1 w-50 mb-3">
        <div id="logoPng" className="logoSvg">
          <img
            src={isDark ? afriexLogoWhite : afriexLogoDark}
            alt="Afriex Logo"
          />
        </div>
      </div>
      <hr className="border-receipt-line dark:border-dark-borderMid" />
    </div>
  );
};

export default ReceiptHeader;
